<template>
  <v-container id="privacy-statement">
    <v-row>
      <v-col class="display-2">
        {{ this.$t("title.privacy_statement") }}
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row>
      <v-col
        style="min-height: 500px"
        v-html="$store.state.config.template_settings.privacy_statement"
      >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "PrivacyStatementPage"
};
</script>

<style scoped></style>
